import { View } from "@/components/ui";
import { cn } from "@/lib/utils";

type Props = {
  size: number;
  checked: boolean;
  onClick(): void;
};

export const RadioDotItem = ({ size, checked, onClick }: Props) => {
  const innerSize = (3 / 4) * size - 2;
  return (
    <View
      onClick={onClick}
      role="radio"
      aria-checked={checked}
      style={{ width: size, height: size }}
      className={cn(
        "flex cursor-pointer flex-row items-center justify-center rounded-full border",
        checked ? "border-brand-primary" : "border-secondary-border",
      )}
    >
      <View className="overflow-hidden rounded-full">
        <View
          className={checked ? "bg-brand-primary" : "bg-transparent"}
          style={{
            width: innerSize,
            height: innerSize,
          }}
        />
      </View>
    </View>
  );
};
